module.exports = []


//////////////////
// WEBPACK FOOTER
// ./src/data/code/team-members.json
// module id = 1948
// module chunks = 112017176246455